import React, { useState } from "react";
import { Link } from "react-router-dom";
import ExternalCompetitions from "./External Competitions";
import ExtCompAthltEntry from "./ExtCompAthltEntry";
import ExternalCompAttempts from "./ExternalCompAttempts";
import ExternalPerformance from "./ExternalPerformance";
import ExternalCompAnalytics from "./ExternalCompAnalytics";
import WLRecord from "./WLRecord";

const ExternalCompTabs = () => {

    const [activeTab, setActiveTab] = useState("Events");

    const tabData = [
        {
            icon: <i className="fas fa-flag-checkered" />,
            name: "Events",
            content: <ExternalCompetitions />
        },
        {
            icon: <i className="fas fa-user-plus" />,
            name: "Athlete Entry",
            content: <ExtCompAthltEntry />
        },
        {
            icon: <i className="fas fa-dumbbell" />,
            name: "Attempts",
            content: <ExternalCompAttempts />
        },
        {
            icon: <i className="fas fa-ranking-star" />,
            name: "Performance",
            content: <ExternalPerformance />
        },
        {
            icon: <i className="fas fa-chart-area" />,
            name: "Competition Analytics",
            content: <ExternalCompAnalytics />
        },
        {
            icon: <i className="fas fa-medal" />,
            name: "Weightlifting Records",
            content: <WLRecord />
        },
    ]

    return (
        <>
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                    <div className="coach-court-list">
                                        <ul className="nav">
                                            {tabData.map((tab, i) => (
                                                <li key={i}>
                                                    <Link
                                                        to="#"
                                                        className={tab.name === activeTab ? "active" : ""}
                                                        onClick={() => setActiveTab(tab.name)}
                                                    >
                                                        {tab.icon} {tab.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    {tabData
                                        .filter(tab => tab.name === activeTab)
                                        .map((tab, i) => (
                                            <div key={i}>{tab.content}</div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ExternalCompTabs;